import { h } from '@stencil/core';
import { ActionDto } from 'client/types';
import EvaButton from './EvaButton';
import { EvaButtonSize, EvaButtonVariant } from './types/eva-types';
import { triggerSubmitChatMessage, triggerTrackEvent } from 'utils/events';

interface ActionButtonProps {
  action: ActionDto;
  doBefore?: () => void;
  doAfter?: () => void;
  disabled?: boolean;
  size?: EvaButtonSize;
  variant?: EvaButtonVariant;
  rootElementClasses?: string;
}

const sendAction = (event: Event, action: ActionDto, before: () => void = () => {}, after: () => void = () => {}) => {
  before();
  event.stopPropagation();
  triggerTrackEvent({
    event_type: 'click',
    event_name: 'click_action_button',
    data: {
      label: action.label,
      actionId: action.actionId,
      params: action.params,
    },
  });
  triggerSubmitChatMessage({
    message: '',
    type: 'USER',
    from: 'FILTER',
    method: 'TEXT',
    action: {
      actionId: action.actionId,
      params: action.params,
    },
  });
  after();
};

/**
 * @deprecated Use {@link GenericButton} instead
 */
export default function ActionButton({ action, doBefore, doAfter, disabled = false, rootElementClasses, variant = '-primary', size = 'md' }: ActionButtonProps) {
  return (
    <EvaButton
      text={action.label}
      size={size}
      variant={variant}
      rootElementClasses={rootElementClasses}
      disabled={disabled}
      onClick={event => sendAction(event, action, doBefore, doAfter)}
    />
  );
}
